import React from 'react';

import { makeUclComponent } from '@rbilabs/universal-components';

import ActionButton from 'components/action-button';

import { VenmoLogo } from '../../../../ucl/themes/icons';

import { IBraintreeButton } from './types';

export const StyledButton = makeUclComponent(ActionButton).withConfig({
  height: '44px',
  accessible: true,
  accessibilityRole: 'button',
  accessibilityLabel: 'Venmo',
  _text: {
    fontSize: 'xl',
    textAlign: 'center',
    color: 'white',
  },
  backgroundColor: '#008CFF',
  padding: 0,
});

export const VenmoStyledButton: React.FC<IBraintreeButton> = ({
  onPress,
  isLoading,
}: IBraintreeButton) => {
  return (
    <StyledButton
      fullWidth
      isLoading={isLoading}
      onPress={onPress}
      rightIcon={<VenmoLogo size={100} height={50} width={100}></VenmoLogo>}
      padding={isLoading ? 3 : 0}
    />
  );
};
